import { SingleDataValue } from '.';
import { ThemedFlex } from '../../theme/ThemedFlex';

export const MiningTileMempoolTxs = ({ mempoolInfo, formatNumber, animate }) => {
  const numberValue = mempoolInfo
    ? `${formatNumber(mempoolInfo.size, 0, false) + ' TXs' ?? "Loading..."}`
    : '';

  return (
    <ThemedFlex
      direction="column"
      mb="12px"
      py="18px"
      px="20px"
      flex={1}
      borderRadius={3}
      className={animate ? 'gray-border-custom gray-border' : ''}
    >
      <SingleDataValue label="Mempool TXs" value={numberValue} />
    </ThemedFlex>
  );
};
